<template>
  <aside class="VisualCta">
    <h3 class="title">{{ content.title }}</h3>
    <CtaButton v-bind="content.cta" class="ctaButton --dark-blue" />
    <SanityImage v-if="content.image" :asset="content.image.asset" class="image" />
  </aside>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: Object,
    },
  },
}
</script>

<style scoped>
.VisualCta {
  background-image: linear-gradient(to bottom, #004370, #0099FF);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--spacing-10) var(--spacing-5) var(--spacing-5);
}
.title {
  font-weight: 600;
  font-size: var(--font-size-8);
  line-height: 1.25;
  color: var(--text-color-white);
  max-width: 21em;
  text-align: center;
}

.ctaButton {
  margin-top: var(--spacing-6);
}

.image {
  margin-top: var(--spacing-8);
  max-height: 15rem;
}
</style>
